<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="400" draggable @close="handleClose">
            <div class="userAdd_man" v-if="state.isShow === true">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item :label="t('scoreRule.levelName')" prop="level_name">
                            <el-input v-model="state.form.level_name" :placeholder="t('common.pleaseInput')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item :label="t('scoreRule.requiredPoints')" prop="required_points">
                            <el-input-number v-model="state.form.required_points" :min="1" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item :label="t('field.status')" prop="status">
                            <el-switch v-model="state.form.status" :active-value="1" :inactive-value="0"
                                :active-text="t('status.enabled')" :inactive-text="t('status.disabled')" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    onMounted,
} from "vue";
import { ElMessage } from "element-plus";
import { saveApi } from "@/api/score/rule";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyScoreRuleFormRules } from "@/utils/scoreListI18n.js";

const emit = defineEmits([]);
defineProps({
    title: {
        type: String,
        default: "",
    },
});

const rules = reactive({
    level_name: [{ required: true, message: "", trigger: "blur" }],
    required_points: [{ required: true, message: "", trigger: "blur" }],
    status: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
    applyScoreRuleFormRules(rules);
};
const { t } = usePageI18n(applyLabels);

const state = reactive({
    dialogVisible: false,
    isShow: true,
    form: {
        "id": 0,
        "level_name": "",
        "required_points": 1,
        "status": 0
    }
});

const getDetailInfo = (row = {}) => {
    if (row?.id) {
        state.form = {
            ...row,
            "required_points": Number(row.required_points),
        }
    } else {
        state.form = {
            "id": 0,
            "level_name": "",
            "required_points": 1,
            "status": 0
        }
    }
}

const open = (row) => {
    state.dialogVisible = true;
    getDetailInfo(row)
};

const handleClose = () => {
    state.dialogVisible = false;
    state.form = {
        "id": 0,
        "level_name": "",
        "required_points": 1,
        "status": 0
    }
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify(state.form)
            saveApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('common.success'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "level_name": "",
                        "required_points": 1,
                        "status": 0
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}
</style>
